var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Select } from '@web/components/ui/Form/Select';
import { useFilters } from '@web/utility/hooks/useFilters';
import { useNavigateTo } from '@web/utility/hooks/useNavigateTo';
import { ApplicationEnum } from '@workalizer/shared';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
export function AppsFilterSelect() {
    var filters = useFilters();
    var navigateTo = useNavigateTo();
    var location = useLocation();
    var t = useTranslation().t;
    var appsOptions = __spreadArray([
        {
            id: null,
            name: t('filters.all'),
            isAll: true
        }
    ], Object.values(ApplicationEnum).map(function (nameApp) { return ({
        id: nameApp,
        name: nameApp
    }); }), true);
    var selectedApp = appsOptions.find(function (app) { return app.id === filters.app; }) || appsOptions[0] || null;
    function onChange(newOption) {
        navigateTo({
            pathname: location.pathname,
            newFilters: { app: newOption.id }
        });
    }
    return (_jsx("div", __assign({ className: "w-full sm:max-w-72" }, { children: _jsx(Select, { label: t('filters.app'), selected: selectedApp, options: appsOptions, onChange: onChange }) })));
}
